import styled from 'styled-components';

import { ButtonBoxSecondary } from '~/src/ui/button';

export const RootBox = styled.div`
  box-sizing: border-box;
  padding: 32px 0;

  font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  color: #4B5057;
  background-color: #F8F8F8;

  @media (min-width: 1200px) {
    padding: 56px 0;
  }

  & * {
    box-sizing: border-box;
  }
`;

export const RootLayout = styled.div`
  margin: 0 auto;
  width: 320px;

  @media (min-width: 480px) {
    width: 480px;
  }

  @media (min-width: 640px) {
    width: 640px;
  }

  @media (min-width: 960px) {
    width: 960px;
  }

  @media (min-width: 1200px) {
    width: 1200px;
  }
`;

export const RootInner = styled.div<{ $isSuccess?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 960px) {
    flex-direction: row;
  }

  & ${ButtonBoxSecondary} {
    @media (max-width: 639px) {
      width: 100%;
    }
  }
`;

export const RootContent = styled.div<{ $isSuccess?: boolean }>`
  order: 2;
  width: 320px;
  padding: 16px 10px;
  text-align: ${({ $isSuccess }): string => ($isSuccess ? 'center' : 'left')};

  @media (min-width: 480px) {
    width: 480px;
  }

  @media (min-width: 640px) {
    width: 640px;
  }

  @media (min-width: 960px) {
    order: 1;
    width: ${({ $isSuccess }): string => ($isSuccess ? '480px' : '400px')};
    text-align: left;
  }

  @media (min-width: 1200px) {
    width: ${({ $isSuccess }): string => ($isSuccess ? '580px' : '500px')};
    padding: 20px;
  }
`;

export const RootDescription = styled.div`
  margin: 0 0 32px;

  @media (min-width: 1200px) {
    margin: 0 0 40px;
  }
`;

export const RootPicture = styled.div`
  order: 1;

  @media (min-width: 960px) {
    order: 2;
  }
`;

export const RootPreviewPicture = styled.div`
  display: none;
  width: 480px;

  @media (min-width: 960px) {
    display: block;
  }
`;

export const RootSuccessPicture = styled.div`
  width: 200px;

  @media (min-width: 960px) {
    width: 380px;
  }
`;

RootBox.displayName = 'RootBox';
RootLayout.displayName = 'RootLayout';
RootInner.displayName = 'RootInner';
RootContent.displayName = 'RootContent';
RootDescription.displayName = 'RootDescription';
RootPicture.displayName = 'RootPicture';
RootPreviewPicture.displayName = 'RootPreviewPicture';
RootSuccessPicture.displayName = 'RootSuccessPicture';
